import React, { useState } from 'react';

import { PrimaryButton, TertiaryButton } from '@rbilabs/components-library';
import { RadioButton } from '@rbilabs/components-library/build/components/radio-button';
import { useIntl } from 'react-intl';

import { PreOrderTimeSlot } from '@rbi-ctg/menu';
import {
  ButtonContainer,
  ButtonWrapper,
  HeaderText,
  ModalContentWrapper,
  PreOrderTimeModalBody,
  RadioButtonContainer,
  TimeSlotList,
  TimeslotItem,
} from 'components/preorder-time-modal/styled';
import {
  PreOrderTimeModalModeConst,
  PreOrderTimeModalProps,
} from 'components/preorder-time-modal/types';
import { getPreOrderLabel, getPreOrderTimeslotId } from 'utils/pre-order';

import { UpsellDialog } from '../upsell-modal/upsell-dialog';

export const PreOrderTimeModal: React.FC<PreOrderTimeModalProps> = ({
  isOpen,
  onClose,
  onPreOrderSlotSelected,
  preOrderTimeSlots,
  mode,
}) => {
  let descriptionText = '';
  let headerText: string | null = null;

  const { formatMessage } = useIntl();
  const [selectedTimeslot, setSelectedTimeslot] = useState<PreOrderTimeSlot | null>(null);

  const getTimeSlotId = (timeslot: PreOrderTimeSlot | null) =>
    timeslot ? getPreOrderTimeslotId(timeslot) : '';

  switch (mode) {
    case PreOrderTimeModalModeConst.DELIVERY_TIMES_UPDATED:
      descriptionText = formatMessage({ id: 'preOrderUpdatedDescription' });
      headerText = formatMessage({ id: 'deliveryTimesUpdatedHeader' });
      break;
    default:
    case PreOrderTimeModalModeConst.PRESELECT:
      descriptionText = formatMessage({ id: 'preOrderPreselectDescription' });
      break;
  }

  return (
    <UpsellDialog
      open={isOpen}
      title={formatMessage({ id: 'scheduleDelivery' })}
      onCloseModal={onClose}
      isMaxHeight={true}
    >
      <ModalContentWrapper>
        <PreOrderTimeModalBody>
          <HeaderText>{headerText}</HeaderText>
          <div>{descriptionText}</div>
          <TimeSlotList>
            {preOrderTimeSlots?.map(timeslot => (
              <TimeslotItem
                key={getTimeSlotId(timeslot)}
                onClick={() => setSelectedTimeslot(timeslot)}
              >
                {getPreOrderLabel(timeslot)}

                <RadioButtonContainer onClick={() => setSelectedTimeslot(timeslot)}>
                  <RadioButton
                    value={getTimeSlotId(timeslot)}
                    checked={getTimeSlotId(timeslot) === getTimeSlotId(selectedTimeslot)}
                    onChange={() => setSelectedTimeslot(timeslot)}
                    label={''}
                  />
                </RadioButtonContainer>
              </TimeslotItem>
            )) ?? []}
          </TimeSlotList>
        </PreOrderTimeModalBody>

        <ButtonContainer>
          <ButtonWrapper>
            <PrimaryButton
              fullWidth
              onClick={() => selectedTimeslot && onPreOrderSlotSelected(selectedTimeslot)}
              disabled={!selectedTimeslot}
            >
              {formatMessage({ id: 'schedule' })}
            </PrimaryButton>
          </ButtonWrapper>

          <ButtonWrapper>
            <TertiaryButton onClick={onClose}>{formatMessage({ id: 'cancel' })}</TertiaryButton>
          </ButtonWrapper>
        </ButtonContainer>
      </ModalContentWrapper>
    </UpsellDialog>
  );
};

export { PreOrderTimeModalModeConst };
